import type { ReactNode } from 'react'
import { clsx } from 'clsx'
import { t } from '@/lang'

type Props = {
  title: string
  required?: boolean
  className?: string
  children: ReactNode
}

/** Rule, small caps heading, content - one block of the consignment form. */
export function Section({ title, required, className, children }: Props) {
  return (
    <section className={clsx('border-t border-neutral-400 pt-7.5', className)}>
      <h2 className="text-section text-secondary-600 uppercase">
        {title}
        {required ? (
          <>
            <span aria-hidden="true" className="ms-1 text-error-600">
              *
            </span>
            <span className="sr-only">{t('common.required')}</span>
          </>
        ) : null}
      </h2>
      <div className="mt-2.5">{children}</div>
    </section>
  )
}
